import { MARKETS_LAST_VISITED_AT as localStorageKey } from '../KEYS';

// Epoch zero for a profile that has never visited /markets, so every
// still-open market counts as new on the first visit.
const EPOCH_ZERO = '1970-01-01T00:00:00.000Z';

export default {
  get(): string {
    return localStorage.getItem(localStorageKey) ?? EPOCH_ZERO;
  },

  set(value: string) {
    localStorage.setItem(localStorageKey, value);
  },

  clear() {
    localStorage.removeItem(localStorageKey);
  },
};
